import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { useInvalidateChannelsList } from '@/entities/channel';
import { verifyTelegramPhoneCode } from '@/shared/api/channels/telegramPersonal';
import { IVerifySmsQueryDTO } from '@/shared/api/channels/types';
import { useNotifications } from '@/shared/ui/Notifications';

export function useVerifySms() {
  const { t } = useTranslation();
  const invalidateChannelsList = useInvalidateChannelsList();

  const { addNotification } = useNotifications();

  const verifySmsMutation = useMutation({
    mutationFn: (data: IVerifySmsQueryDTO) =>
      verifyTelegramPhoneCode(data.channelId, { phone: data.phone, code: data.code }),
    onError: (error) => {
      addNotification({
        title: error.message || t('common:errors.genericTitle'),
        caption: error?.data?.details || t('common:errors.generic'),
      });
    },
  });

  const verifySms = async (data: IVerifySmsQueryDTO) => {
    return verifySmsMutation.mutateAsync(data, {
      onSuccess: () => {
        Promise.all([invalidateChannelsList()]);
      },
    });
  };

  return { verifySms, ...verifySmsMutation };
}
